import { extractFunctionError } from '@/lib/functions';
import { supabase } from '@/lib/supabase';

/**
 * Διαγράφει οριστικά τον λογαριασμό του τρέχοντος χρήστη (μέσω Edge Function).
 * Μετά την επιτυχία, ο καλών πρέπει να κάνει signOut για να καθαρίσει τη session.
 */
export async function deleteAccount(): Promise<void> {
  const { error } = await supabase.functions.invoke('delete-account', { method: 'POST' });
  if (error) throw new Error(await extractFunctionError(error, 'Η διαγραφή λογαριασμού απέτυχε.'));
}
